import React from "react";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { DialogBoxMedium } from "../../common/dialog.medium";
import { CustomizedSnackbars } from "../../common/snackbars";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const API_URL = process.env.REACT_APP_API_URL;

export const ExpenseCategoryComponent = (props) => {
    return (
        <React.Fragment>
            {!props.permisionError && (
                <div className={"section-main"}>
                    <div className={"section-header"}>
                        <div className={"col-left"}></div>

                        <div className={"action"}>
                            {props.EditPermission && (
                                <Button
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    type="submit"
                                    onClick={
                                        props.OnAddCategoryClick
                                    }
                                >
                                    Add
                                </Button>
                            )}
                        </div>
                    </div>

                    <div className={"section-body"}>
                        <Paper>
                            <TableContainer component={Paper}>
                                <Table
                                    aria-label="Category List"
                                    className={
                                        "list-table_basic steps-table"
                                    }
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                ID
                                            </TableCell>

                                            <TableCell>
                                                Name
                                            </TableCell>

                                            <TableCell>
                                                Status
                                            </TableCell>

                                            <TableCell>
                                                Description
                                            </TableCell>

                                            <TableCell>
                                                Declaration
                                            </TableCell>

                                            <TableCell>
                                                Actions
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody
                                        className={"tbody"}
                                    >
                                        {props.CategoryList.length >
                                        0 ? (
                                            props.CategoryList.map(
                                                (category) => (
                                                    <TableRow
                                                        key={
                                                            category.id
                                                        }
                                                    >
                                                        <TableCell>
                                                            {
                                                                category.id
                                                            }
                                                        </TableCell>

                                                        <TableCell>
                                                            {
                                                                category.name
                                                            }
                                                        </TableCell>

                                                        <TableCell>
                                                            {
                                                                category.status_name
                                                            }
                                                        </TableCell>

                                                        <TableCell>
                                                            {
                                                                category.description
                                                            }
                                                        </TableCell>

                                                        <TableCell>
                                                            {
                                                                category.declaration
                                                            }
                                                        </TableCell>

                                                        <TableCell>
                                                            {props.EditPermission && (
                                                                <Tooltip
                                                                    title="Edit"
                                                                    aria-label="edit"
                                                                >
                                                                    <IconButton
                                                                        className={
                                                                            "action-btn"
                                                                        }
                                                                        edge="end"
                                                                        aria-label="Edit"
                                                                    >
                                                                        <EditIcon
                                                                            fontSize="small"
                                                                            onClick={props.EditCategoryClick(
                                                                                category.id
                                                                            )}
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}

                                                            {props.DeletePermission && (
                                                                <Tooltip
                                                                    title="Delete"
                                                                    aria-label="delete"
                                                                >
                                                                    <IconButton
                                                                        className={
                                                                            "action-btn"
                                                                        }
                                                                        edge="end"
                                                                        aria-label="Delete"
                                                                    >
                                                                        <DeleteIcon
                                                                            fontSize="small"
                                                                            onClick={props.DeleteCategoryClick(
                                                                                category.id
                                                                            )}
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            )
                                        ) : (
                                            <TableRow>
                                                <TableCell
                                                    colSpan={6}
                                                >
                                                    No records found
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </div>
                </div>
            )}

            {props.PopupType === "add" && (
                <DialogBoxMedium
                    Open={props.Open}
                    Cancel={props.OnClose}
                    Title={
                        props.IsEditable
                            ? "Edit Category"
                            : "Add Category"
                    }
                    OnSubmit={props.HandleSubmit}
                    Content={
                        <DialogContent FormProps={props} />
                    }
                />
            )}

            {props.PopupType === "delete" && (
                <DialogBoxMedium
                    Open={props.Open}
                    Cancel={props.OnClose}
                    OnSubmit={props.DeleteCategory}
                    Title="Confirm Delete"
                    ButtonName="Ok"
                    Content={
                        <DialogWithConfirmMessage
                            msg="Do you really want to delete this category ?"
                        />
                    }
                />
            )}

            {props.SnackbarOpen && (
                <CustomizedSnackbars
                    open={props.SnackbarOpen}
                    variant={props.SnackbarVarient}
                    message={props.SnackbarMsg}
                    handleClose={props.SnackbarClose}
                />
            )}
        </React.Fragment>
    );
};

const DialogContent = (props) => {
    const {
        FormFields,
        HandleOnChange,
        Errors,
        Statuses,
    } = props.FormProps;

    return (
        <form
            className="form-fullwidth"
            onSubmit={props.OnSubmit}
        >
            <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                    <FormControl fullWidth>
                        <TextField
                            variant="standard"
                            required
                            id="name"
                            name="name"
                            label="Name"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={FormFields?.name || ""}
                            onChange={HandleOnChange}
                            error={Errors.name && true}
                            helperText={Errors.name}
                        />

                        <TextField
                            variant="standard"
                            required
                            id="description"
                            name="description"
                            label="Description"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={
                                FormFields?.description || ""
                            }
                            onChange={HandleOnChange}
                            error={
                                Errors.description && true
                            }
                            helperText={Errors.description}
                        />

                        <TextField
                            variant="standard"
                            id="declaration"
                            name="declaration"
                            label="Declaration"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={
                                FormFields?.declaration || ""
                            }
                            onChange={HandleOnChange}
                            error={
                                Errors.declaration && true
                            }
                            helperText={Errors.declaration}
                        />

                        <Select
                            value={
                                typeof FormFields.status !==
                                "undefined"
                                    ? FormFields.status
                                    : ""
                            }
                            onChange={HandleOnChange}
                            inputProps={{
                                name: "status",
                                id: "status",
                            }}
                        >
                            {typeof Statuses != "undefined" &&
                                Statuses.map((t, i) => (
                                    <MenuItem
                                        key={i}
                                        value={t.id}
                                    >
                                        {
                                            t.expense_category_status
                                        }
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </form>
    );
};

const DialogWithConfirmMessage = (props) => {
    return <>{props.msg}</>;
};
